import { apiGet, apiPatch } from './client';
import type { Company, CompanyBatchRequest } from '../types/Company';

export function getCompanies(): Promise<Company[]> { return apiGet<Company[]>('/api/companies'); }

export function saveBatchCompanies(added: Company[], modified: Company[], deletedIds: number[]): Promise<Company[]> {
  return apiPatch<CompanyBatchRequest, Company[]>('/api/companies/batch', { added, modified, deleted: deletedIds });
}
